/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-setting-icon[_ngcontent-%COMP%]{position:absolute;top:0;left:6%;opacity:.07;font-size:550px!important;z-index:1}[_nghost-%COMP%]     .mat-list-item-content{justify-content:space-between!important}"];
export { styles as styles };
